import { CoreIcon } from '../core-icon';
import mochiCoinCircleSVG from '../../assets/icons/mochi-coin-circle.svg';
import type { IconProps } from '../core-icon';

export const MochiCoinCircleIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={mochiCoinCircleSVG} {...props} />;
};
